module.exports = __webpack_public_path__ + "img/itsm9.7526946d.png";